<div class="menu-mobile" *ngIf="template == 'home'">
      <ul>
            <li (click)="toRoute('/')">
                  <div class="icon">
                        <i class="fa-solid fa-house"></i>
                  </div>
                  <span>Início</span>
            </li>
            <li (click)="toRoute('/produtos')">
                  <div class="icon">
                        <i class="fa-regular fa-gem"></i>
                  </div>
                  <span>Produtos</span>
            </li>
            <li (click)="openWhats()">
                  <div class="icon">
                        <i class="fa-brands fa-whatsapp"></i>
                  </div>
                  <span>WhatsApp</span>
            </li>
            <li>

            </li>
      </ul>
</div>
<div class="menu-mobile" *ngIf="template == 'products'">  
      <ul>
            <li (click)="toRoute('/')">
                  <div class="icon">
                        <i class="fa-solid fa-house"></i>
                  </div>
                  <span>Início</span>
            </li>
            <li (click)="openCategories()">
                  <div class="icon">  
                        <i class="fa-solid fa-list-ul"></i>
                  </div>
                  <span>Categorias</span>
            </li>
            <li (click)="openWhats()">
                  <div class="icon">
                        <i class="fa-brands fa-whatsapp"></i>
                  </div>
                  <span>WhatsApp</span>
            </li>
            <li>

            </li>
      </ul>
</div>
<div class="menu-categories" *ngIf="template == 'products'" [ngClass]="{'show': openMenu}">
      <div class="header">
            <h3>Joias por categoria</h3>
            <div class="icon" (click)="close()">
                  <i class="fa-solid fa-xmark"></i>
            </div>
      </div>  
      <div class="content">
            <div class="item" *ngFor="let c of categorias">
                  <a routerLink="/produtos/{{c.apelido}}" [alt]="c.titulo" (click)="toRoute('/produtos',c.apelido)">
                        <span>{{c.titulo}}</span>
                  </a>
            </div>
      </div>
</div>

